export default __webpack_public_path__ + "static/media/G0680.34I-26416_-16238_0.1666267140000.d3f0c86c.jpg";